import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DelegaTimesheet, NuovaDelega, UtenteDelegabile } from '../interfaces/delega.interface';
import { FiltroDeleghe } from '../interfaces/filtro-deleghe.interface';

@Injectable({ providedIn: 'root' })
export class DelegheService {
  constructor(private readonly http: HttpClient) {}

  private readonly baseUrl = 'api/deleghe';

  public getStoricoDeleghe(filter: FiltroDeleghe): Observable<any> {
    const responseType = filter.flagExport ? 'blob' : 'json';
    return this.http.post<FiltroDeleghe>(
      this.baseUrl + '/storico',
      filter,
      { responseType: responseType as any }
    );
  }

  public getStoricoDelegheCount(filter: FiltroDeleghe): Observable<number> {
    return this.http.post<number>(
      this.baseUrl + '/storico/count',
      filter
    );
  }

  public getDelegheAttive(): Observable<DelegaTimesheet[]> {
    return this.http.get<DelegaTimesheet[]>(this.baseUrl + '/attive');
  }

  public getMieDeleghe(): Observable<DelegaTimesheet[]> {
    return this.http.get<DelegaTimesheet[]>(this.baseUrl + '/mie');
  }

  public inserisciDelega(delega: NuovaDelega): Observable<DelegaTimesheet> {
    return this.http.post<DelegaTimesheet>(this.baseUrl, delega);
  }

  public disattivaDelega(id: number): Observable<any> {
    return this.http.delete<any>(this.baseUrl + '/' + id);
  }

  public getDeleganti(): Observable<UtenteDelegabile[]> {
    return this.http.get<UtenteDelegabile[]>(this.baseUrl + '/deleganti');
  }

  public getDelegabili(): Observable<UtenteDelegabile[]> {
    return this.http.get<UtenteDelegabile[]>(this.baseUrl + '/delegabili');
  }
}
